export const Environment = {
    is_development: true
}
